import { useEffect, useState } from 'react';

import { useBooking } from '../../model/store/booking';

import type { IBookingDoctorData } from '@/entities/booking/model/types';

interface UseCurrentBookingProps {
  doctorId: number;
  medcenterId: number | null;
  bookingData: IBookingDoctorData[];
}

export const useCurrentBooking = ({ doctorId, medcenterId, bookingData }: UseCurrentBookingProps) => {
  const { booking, createBooking, setIinRequired } = useBooking();
  const [currentBooking, setCurrentBooking] = useState(
    booking.find(item => item.doctorId === doctorId && item.medcenterId === medcenterId),
  );

  useEffect(() => {
    const bookingDataItem = medcenterId ? bookingData.find(data => data.medcenterId === medcenterId) : bookingData[0];
    const actualMedcenterId = medcenterId || bookingDataItem?.medcenterId || 0;

    if (bookingDataItem?.onlineBooking?.schedule) {
      const initialDay = bookingDataItem.onlineBooking.schedule.find(day => day.isWork && day.timeslots);
      const initialSlot = initialDay?.timeslots?.[0] || '';

      if (doctorId && !booking.find(item => item.doctorId === doctorId && item.medcenterId === actualMedcenterId)) {
        createBooking({
          doctorId,
          medcenterId: actualMedcenterId,
          initialDay: initialDay || null,
          initialSlot,
        });
      }
    } else {
      createBooking({
        doctorId,
        medcenterId: actualMedcenterId,
        initialDay: null,
        initialSlot: '',
      });
    }
  }, [doctorId, medcenterId, bookingData]);

  useEffect(() => {
    const bookingDataItem = medcenterId ? bookingData.find(data => data.medcenterId === medcenterId) : bookingData[0];
    const actualMedcenterId = medcenterId || bookingDataItem?.medcenterId || 0;

    setCurrentBooking(booking.find(item => item.doctorId === doctorId && item.medcenterId === actualMedcenterId));
  }, [medcenterId, bookingData, booking, doctorId]);

  useEffect(() => {
    if (medcenterId) {
      const bookingDataItem = bookingData.find(data => data.medcenterId === medcenterId);

      if (bookingDataItem) {
        setIinRequired({
          iin: bookingDataItem.onlineBooking?.iinRequired,
          id: doctorId,
        });
      }
    } else {
      setIinRequired({
        iin: bookingData.length && bookingData[0].onlineBooking ? bookingData[0].onlineBooking.iinRequired : false,
        id: doctorId,
      });
    }
  }, [bookingData, medcenterId]);

  useEffect(() => {
    const bookingDataItem = medcenterId ? bookingData.find(data => data.medcenterId === medcenterId) : bookingData[0];
    const actualMedcenterId = medcenterId || bookingDataItem?.medcenterId || 0;

    setCurrentBooking(booking.find(item => item.doctorId === doctorId && item.medcenterId === actualMedcenterId));
  }, [booking]);

  return { currentBooking };
};
